var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import ButtonGroup from '../button-group';
import { Styled } from './style';
var DEBUG = false;
export var RotationValue;
(function (RotationValue) {
    RotationValue[RotationValue["_0"] = 0] = "_0";
    RotationValue[RotationValue["_90"] = 1] = "_90";
    RotationValue[RotationValue["_180"] = 2] = "_180";
    RotationValue[RotationValue["_270"] = 3] = "_270";
})(RotationValue || (RotationValue = {}));
var ButtonRotation = /** @class */ (function (_super) {
    __extends(ButtonRotation, _super);
    function ButtonRotation(props) {
        var _this = _super.call(this, props) || this;
        _this.handlerOnClick = function (value) {
            if (DEBUG) {
                console.log('click at', value);
            }
            _this.setState({ value: value });
            if (_this.props.onChanged) {
                _this.props.onChanged(value);
            }
        };
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    ButtonRotation.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value };
        }
        return null;
    };
    ButtonRotation.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        return (React.createElement(Styled, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { active: value === RotationValue._0, onClick: function () { return _this.handlerOnClick(RotationValue._0); }, disabled: this.props.disabled || false }, "0\u00B0"),
                React.createElement(Button, { active: value === RotationValue._90, onClick: function () { return _this.handlerOnClick(RotationValue._90); }, disabled: this.props.disabled || false }, "90\u00B0"),
                React.createElement(Button, { active: value === RotationValue._180, onClick: function () { return _this.handlerOnClick(RotationValue._180); }, disabled: this.props.disabled || false }, "180\u00B0"),
                React.createElement(Button, { active: value === RotationValue._270, onClick: function () { return _this.handlerOnClick(RotationValue._270); }, disabled: this.props.disabled || false }, "270\u00B0"))));
    };
    ButtonRotation.defaultProps = {
        value: RotationValue._0,
    };
    return ButtonRotation;
}(React.Component));
export default ButtonRotation;
//# sourceMappingURL=index.js.map